const config = {
  error: {
    iconName: 'CrossIcon',
    type: 'error',
  },
  success: {
    iconName: 'CheckIcon',
    type: 'success',
  },
  info: {
    iconName: 'BubbleTextIcon',
    type: 'info',
  },
  warning: {
    iconName: 'BubbleExclamationIcon',
    type: 'warning',
  },
  download: {
    iconName: 'FileEmptyIcon',
    type: 'info',
  },
};
const getType = (type) => (config[type] || {});
export const errorNotification = getType('error');
export const successNotification = getType('success');
export const infoNotification = getType('info');
export const warningNotification = getType('warning');
export const downloadNotification = getType('download');
